export default "__VITE_ASSET__CS00aWAy__"